<template>
  <footer class="fixed bottom-0 left-0 z-20 w-full flex items-center justify-between border-t border-gray-200 bg-gray-200 px-1 shadow dark:border-gray-600 dark:bg-gray-800">
    <span class="text-sm text-black sm:text-center dark:text-white" />
    <span class="text-sm text-black sm:text-center dark:text-white">© 2023 <a href="https://www.sberg.net/" class="hover:underline" target="_blank">sberg it-systeme GmbH</a></span>
  </footer>
</template>
